import React from 'react';
import { graphql } from 'gatsby'
//import { sanitizeHtmlContent } from '../utils/utils'

import {
  Divider,
} from 'semantic-ui-react';

export const FragmentContentDivider = graphql`
  fragment ContentDivider on ContentDivider {
    contentItemId
    contentType
    displayText
    hidden
    dividerMargin
  }
`

export default function ContentDivider(props) {
  //console.log('ContentDivider - props', props);

  //const textColor = props.text_color ? props.text_color : props.header_text_color ? props.header_text_color : null;

  const {
    hidden,
    dividerMargin,
  } = props;
  
  return (
    <>
      {/* <style dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize([
          '#layout-wrapper a.ui.button.postUpSignUpButton {',
          '  color: '+ textColor +';',
          '  box-shadow: inset 0 0 0 2px '+ textColor +' !important;',
          '}',
          '#layout-wrapper a.ui.button.postUpSignUpButton:hover {',
          '  color: '+ props.header_background_color +' !important;',
          '  background: '+ textColor +' !important;',
          '}'
          ].join('\n'))
        }}>
      </style> */}
      <div className={'site-content-divider'}>
        <Divider 
          hidden={hidden ? hidden : null} 
          style={dividerMargin ? {margin: dividerMargin} : null}
        />
      </div>
    </>
  )
}
